/**
 * Specialty / scope helpers for the endopod fork.
 *
 * Endopod is a single-modality product (endoscopy only), so the scope
 * is fixed at compile time. The legacy multi-specialty scope code +
 * patient/referring MRN-narrowing are RETIRED with the move to the
 * 4-role RBAC matrix in 07-rbac-matrix.md.
 */

import type { AuthState } from "./types";
import { canUserUi } from "./types";
import type { Specialty } from "../specialty/config";

/** This modality's specialty — endoscopy. */
export const MODALITY_SPECIALTY: Specialty = "endoscopy";

/** Modality codes (DICOM Modality tag values) this product handles. */
export const MODALITY_CODES: ReadonlyArray<string> = ["ES"];

/**
 * Single-specialty product: any user with a User-UI role sees the one
 * specialty this modality is built for.
 */
export function canSeeSpecialty(auth: AuthState | null, s: Specialty): boolean {
  return canUserUi(auth) && s === MODALITY_SPECIALTY;
}

export function singleSpecialty(auth: AuthState | null): Specialty | null {
  return canUserUi(auth) ? MODALITY_SPECIALTY : null;
}

/** Modality-code filter for QIDO results. Always returns the fixed set
 *  for this product so cached cross-modality results can't bleed in. */
export function modalitiesInScope(_auth: AuthState | null): Set<string> {
  return new Set(MODALITY_CODES);
}
